import { getZipCodeTemplate, getVueZipCodeTemplate } from "../../shortcodes/templates";

let zipCodeShortcode = null;
const visualizeZipCodeShortcode = content => {
  zipCodeShortcode = content.querySelectorAll('[data-wrapper-id="zip-code-shortcode"]');

  if (zipCodeShortcode.length > 0) {
    zipCodeShortcode.forEach(item => {
      item.innerHTML = getZipCodeTemplate();
    });
  }
};

const serializeZipCodeShortcode = content => {
  const zipCodeShortcodeWidget = content.querySelectorAll('[data-wrapper-id="zip-code-shortcode"]');
  if (zipCodeShortcodeWidget.length > 0) {
    zipCodeShortcodeWidget.forEach(item => {
      item.innerHTML = getVueZipCodeTemplate();
    });
  }
};

export { visualizeZipCodeShortcode, serializeZipCodeShortcode };
